import { HypertuneProvider } from 'generated/hypertune.react'
import { PropsWithChildren } from 'react'
import { IS_PROD } from 'constants/envs'
import { REFRESH_INTERVAL_MS } from 'lib/hypertune/constants'
import { Language } from 'types/language'

export default function AppHypertuneProvider({ children, lng }: PropsWithChildren<{ lng: Language }>) {
  return (
    <HypertuneProvider
      createSourceOptions={{ token: process.env.NEXT_PUBLIC_HYPERTUNE_TOKEN!, initDataRefreshIntervalMs: REFRESH_INTERVAL_MS }}
      rootArgs={{
        context: {
          environment: IS_PROD ? 'production' : 'test',
          user: { id: '1', language: lng }
        }
      }}
    >
      {children}
    </HypertuneProvider>
  )
}
